const PRODUCT_ABBREVIATIONS = [
  [/Uusiutuva\s+Diesel/gi, "RE HVO Diesel"],
  [/Uusiutuva\s+Polttoöljy/gi, "RE HVO"],
  [/Moottoripolttoöljy/gi, "MPÖ"],
  [/Polttoöljy/gi, "PÖ"],
];

export function abbreviateDailyProductName(productName = "") {
  return PRODUCT_ABBREVIATIONS.reduce(
    (label, [pattern, replacement]) => label.replace(pattern, replacement),
    productName
  ).replace(/\s*\(\s*RE\s*HVO\s*\)/gi, "").trim();
}

function wrapWords(text, maximumLineLength) {
  return text.split(/\s+/).reduce((lines, word) => {
    const currentLine = lines.at(-1) || "";
    if (currentLine && `${currentLine} ${word}`.length > maximumLineLength) {
      lines.push(word);
    } else {
      lines[lines.length - 1] = currentLine ? `${currentLine} ${word}` : word;
    }
    return lines;
  }, [""]);
}

export function formatCompactDailyChartLabel({ postalCode, productName }) {
  const productLines = wrapWords(abbreviateDailyProductName(productName), 24);
  return [postalCode || "—", ...productLines].filter(Boolean).join("\n");
}
